
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Box } from '@mui/material';
import { removePopup, getUserData } from "../../../../redux/actions";
import { setTokens } from '../../../../redux/slices/tokenSlice';
import DynamicLink from 'components/dynamic_link';
import { getMediaPath, generateTestId } from "../../../../app/functions";
import IdLoginForm from './IdLoginForm';
import FirstLoginForm from './FirstLoginForm';
import LoginForm from './LoginForm';
import { TextHot } from 'components/common/TextHot';
import { spacing } from 'common/theme';


import { PhoneValidationModal } from 'components/common/PhoneValidationModal';

export const LOGIN_CODES = {
    SUCCESS_LOGIN: 163,
}

class LoginRegistration extends Component {

    constructor(props) {
        super(props);
        this.testID = props.testID || 'login-registration';

        this.state = {
            type: 'registration_form',
            phone: '',
            user_id: '',
            firstLoginValidationFailed: false,
            firstLoginValidationFailedMsg: '',
            isPhoneValidationOpen: false,
            otpResponseData: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.firstLogin && this.props.firstLogin.hasOwnProperty('id') && prevProps.firstLogin !== this.props.firstLogin) {
            this.props.stepUp({ before: 1, after: 2, processType: 'Register' });
        }
    }

    setFirstLoginValidationFailed = (failed) => {
        this.setState({ firstLoginValidationFailed: failed });
    };
    setFirstLoginValidationFailedMsg = (msg) => {
        this.setState({ firstLoginValidationFailedMsg: msg });
    };
    getPhone = (num) => {
        this.setState({ phone: num });
    };
    getUserId = (num) => {
        this.setState({ user_id: num });
    };

    handleNavbarClick = (form) => {
        this.setState({ type: form });
    };

    handleOtpRequested = ({ initialOtpResponse, phone, userId }) => {
        this.setState({
            phone,
            user_id: userId,
            otpResponseData: initialOtpResponse,
            isPhoneValidationOpen: true, 
        });
    };

    handleVerificationSuccess = async (otpResult) => {
        try {
            const sessionToken = otpResult?.sessionToken || otpResult?.authToken;
            if (sessionToken) {
                this.props.setTokens && this.props.setTokens({ sessionToken });
            }
            const authToken = otpResult?.accessToken || otpResult?.token || otpResult?.authToken;
            if (authToken) {
                this.props.setTokens && this.props.setTokens({ authToken });
            }

            if (this.props.getUserData) {
                await this.props.getUserData();
            }

            if (this.props.onLogin) {
                await this.props.onLogin(otpResult);
            }
        } finally {
            this.setState({ isPhoneValidationOpen: false });
            this.props.removePopup && this.props.removePopup();
        }
    };

    getForm = (form) => {
        if (this.state.isPhoneValidationOpen && form === 'login_form') {
            return null;
        }

        if (form === 'registration_form') {
            return (
                <FirstLoginForm 
                    deviceState={this.props.deviceState}
                    text={this.props.text}
                    stepUp={this.props.stepUp} 
                    firstLoginValidationFailed={this.state.firstLoginValidationFailed}
                    firstLoginValidationFailedMsg={this.state.firstLoginValidationFailedMsg}
                    setFirstLoginValidationFailed={this.setFirstLoginValidationFailed}
                    setFirstLoginValidationFailedMsg={this.setFirstLoginValidationFailedMsg}
                    testID={generateTestId(this.testID, 'first-login-form')}
                />
            );
        } else if (form === 'id_login_form') {
            return (
                <IdLoginForm
                    deviceState={this.props.deviceState}
                    text={this.props.text}
                    onSuccess={() => this.setState({ type: 'registration_4_digits_form' })}
                    testID={generateTestId(this.testID, 'id-login-form')}
                />
            );
        } else {
            return (
                <LoginForm 
                    text={this.props.text}
                    setUserId={this.getUserId} 
                    setPhone={this.getPhone} 
                    onLogin={this.props.onLogin}
                    onOtpRequested={this.handleOtpRequested}
                    testID={generateTestId(this.testID, 'login-form')}
                />
            );
        }
    };

    getBanners = () => {
        const isMobile = this.props.deviceState === 'mobile';
        const banners = this.props.banners.login_banners || {};
        let res = [];

        for (let key in banners) {
            res.push(
                <div key={key} className='banner-wrapper' onClick={() => this.props.removePopup()}>
                    <DynamicLink data={banners[key].link}>
                        <img src={getMediaPath(isMobile ? banners[key].mobileImage : banners[key].image)} alt='/' />
                    </DynamicLink>
                </div>
            )
        }

        return res;
    };

    render() {
        const text = this.props.text;
        const subtitleText = this.props.subtitleText;

        const type = this.state.type;

        let loginServerErrMsg = '';
        let registrationServerErrMsg = '';

        if (this.props.login && this.props.login.hasOwnProperty('content')) {
            loginServerErrMsg = this.props.login.content;
        }

        if (this.props.firstLogin && this.props.firstLogin.hasOwnProperty('content')) {
            registrationServerErrMsg = this.props.firstLogin.content;
        }

        const form = this.props.loginFormName;
        let title = '';
        if (form === 'registration_form') {
            title = text['login_first_entrance'];
        } else if (form === 'id_login_form') {
            title = text['login_log_in'];
        } else {
            title = text['login_log_in'];
        }

        return (
            <Box className='login'>
                <Box className='form-container'>
                    <Box 
                        className='front-form' 
                        sx={{ 
                            textAlign: 'center', 
                            pb: `${spacing.xl}px`
                        }}
                        testID={generateTestId(this.testID, 'header')}
                    >
                        <TextHot 
                            size="xxxl"
                            color="secondary"
                            component="span"
                            sx={{ display: 'block', textAlign: 'center', mb: 1.5 }}
                            testID={generateTestId(this.testID, 'subtitle')}
                        >
                            {subtitleText ?? text['login_subtitle']}
                        </TextHot>
                        <TextHot 
                            size="xxxxl"
                            bold="extraBold"
                            color="primary"
                            testID={generateTestId(this.testID, 'title')}
                        >
                            {title}
                        </TextHot>
                    </Box>

                    {this.getForm(form)}

                    {type === 'registration_form' && registrationServerErrMsg && (
                        <TextHot 
                            size="l"
                            color="error"
                            sx={{ textAlign: 'center', mt: 2 }}
                            testID={generateTestId(this.testID, 'registration-error')}
                        >
                            {registrationServerErrMsg}
                        </TextHot>
                    )}
                    {type === 'login_form' && loginServerErrMsg && (
                        <TextHot 
                            size="l"
                            color="error"
                            sx={{ textAlign: 'center', mt: 2 }}
                            testID={generateTestId(this.testID, 'login-error')}
                        >
                            {loginServerErrMsg}
                        </TextHot>
                    )}
                </Box>

                <PhoneValidationModal
                    open={this.state.isPhoneValidationOpen}
                    onClose={() => this.setState({ isPhoneValidationOpen: false })}
                    phone={this.state.phone}
                    userId={this.state.user_id}
                    initialOtpResponse={this.state.otpResponseData}
                    onVerificationSuccess={this.handleVerificationSuccess}
                    process="login"
                    testID={generateTestId(this.testID, 'phone-validation-modal')}
                />
            </Box>
        )
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        login: store.config.LoginReturn,
        firstLogin: store.config.FirstLoginReturn,
        banners: store.config.BannersArr,
        loginFormName: store.state.loginFormName,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        removePopup: () => dispatch(removePopup()),
        getUserData: () => dispatch(getUserData()),
        setTokens: (payload) => dispatch(setTokens(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(LoginRegistration);
